import { chef, dishes, spices, recipe } from 'cookery';
import productList from '../productList'

const { sectionTpl } = dishes;

const production = (data = {}) => {
    return sectionTpl({ contentHtml: productList() });
}

export default production;